// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f4605557","455":"aa969e44","977":"8cb66bbd"}[chunkId] + ".chunk.js";
};